import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Card, Divider, Grid, Tab, Paper, Container, Backdrop } from "@material-ui/core";
import { CheckSharp, PrintSharp } from "@material-ui/icons";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { Documents } from "./components/Documents";
import { VehicleDriverDetails } from "./components/VehicleDriverDetails/VehicleDriverDetails";
import { WebCam } from "./components/WebCam/WebCam";
import { expandNextSection, setExpandNextSection } from "src/app-redux/vehicle/vehicleSlice";
import { getPrintFile } from "src/app-redux/common-actions";
import { loader } from "src/app-redux/gate-entry/gateEntrySlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import moment from "moment";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import CommonLoader from "src/components/Loader/CommonLoader";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      color: "#000",
      lineHeight: "28px",
    },
    breadcrumbs: {
      fontSize: theme.typography.pxToRem(12),
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    ".hidden": {
      overflow: "hidden",
    },
    accordionsSection: {
      overflow: "auto",
    },
    seeMoreBlock: {
      maxWidth: "150px",
    },
    moreInfoBlock: {
      width: "100%",
      display: "none",
      background: "#f6f6f6",
      position: "absolute",
      top: "40px",
      paddingBottom: "10px",
    },
    ".seeMoreBlock:hover > .moreInfoBlock": {
      background: "red",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
    tabIconShow: {
      "& .MuiSvgIcon-root": {
        display: "block",
        position: "absolute",
        right: "10px",
        fill: "white",
        background: "green",
        borderRadius: "50%",
      },
    },
    tabIconHide: {
      "& .MuiSvgIcon-root": {
        display: "none",
      },
    },
    gateInOuterCard: {
      borderRight: "1px solid rgba(0, 0, 0, 0.12)",
      marginBottom: "10px",
      boxShadow: "none",
      "& .MuiTabs-vertical": {
        borderRight: "none!important",
      },
    },
  })
);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};
export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
export default function GateIn({}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: any }>();
  const [value, setValue] = useState(0);
  const [expandedAccordion, setExpandedAccordion] = useState({
    vehicleDriverDetails: false,
    doc: false,
    ivr: false,
  });
  const moduleName = "Gate Entry";
  const [pageHeading, setPageHeading] = useState("Gate-In");

  const checkDetails = false;
  const checkFileAttachments = false;
  const checkCaptureImage = false;
  const expandAttachments: any = useAppSelector(expandNextSection);
  const loading = useAppSelector(loader);

  useEffect(() => {
    document.body.classList.add("hidden");
    if (id) {
      setPageHeading("Gate-In");
      document.body.classList.add("hidden");
    } else {
      document.body.classList.remove("hidden");
    }
    expandAttachments ? dispatch(setExpandNextSection(false)) : "";
  }, [id]);

  useEffect(() => {
    setExpandedAccordion({
      ...expandedAccordion,
      doc: expandAttachments,
    });
  }, [expandAttachments]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    if (newValue == 3) {
      setIsOpenPrintDailog(true);
    } else {
      setExpandedAccordion({
        ...expandedAccordion,
        vehicleDriverDetails: newValue === 0,
        doc: newValue === 1,
        ivr: newValue === 2,
      });
    }
  };

  const updateExpandedStatus = (type: number) => {
    setValue(type);
    switch (type) {
      case 0:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            vehicleDriverDetails: !prev.vehicleDriverDetails,
          };
        });
        return;
      case 1:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            doc: !prev.doc,
          };
        });
        return;
      case 2:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            ivr: !prev.ivr,
          };
        });
        return;

      default:
        return;
    }
  };

  const [isOpenPrintDailog, setIsOpenPrintDailog] = useState<boolean>(false);

  const printReceipt = async (isDuplicate: string) => {
    setIsOpenPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-entry-slip-by-vehicle-id/${id}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={"/gate-entry"} />
      <Backdrop className={classes.backdrop} open={loading}>
        <CommonLoader />
      </Backdrop>
      {/* Dialog for Print Receipt */}
      <DuplicateReceiptDialog
        isOpen={isOpenPrintDailog}
        handleOriginal={() => {
          printReceipt("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceipt("1");
        }}
        onClose={() => {
          setIsOpenPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={4} md={3} lg={2} component={Card} className={classes.gateInOuterCard}>
                <div className="gateIn">
                  {id ? (
                    <CommonTabs value={value} handleChange={handleChange} tabMinHeight={800}>
                      <Tab
                        label="Gate-Entry Form"
                        {...a11yProps(0)}
                        icon={<CheckSharp />}
                        className={checkDetails ? classes.tabIconShow : classes.tabIconHide}
                      />
                      <Tab
                        label="File Attachments"
                        {...a11yProps(1)}
                        icon={<CheckSharp />}
                        className={checkFileAttachments ? classes.tabIconShow : classes.tabIconHide}
                      />
                      <Tab
                        label="Take Pictures"
                        {...a11yProps(2)}
                        icon={<CheckSharp />}
                        className={checkCaptureImage ? classes.tabIconShow : classes.tabIconHide}
                      />
                    </CommonTabs>
                  ) : (
                    <CommonTabs value={value} handleChange={handleChange}>
                      <Tab label="Gate-Entry Form" {...a11yProps(0)} />
                      <Tab disabled label="File Attachments" {...a11yProps(1)} />
                      <Tab disabled label="Take Pictures" {...a11yProps(2)} />
                    </CommonTabs>
                  )}
                </div>
              </Grid>

              <Grid item xs={8} md={9} lg={10} component={Card} className={classes.tabCardContent}>
                <Container className="gateInTabs">
                  <>
                    <Box style={{ height: "40px" }}>
                      <CommonButton
                        style={{
                          minWidth: "175px",
                          float: "right",
                        }}
                        cssClass="customSubmitBtn"
                        isGreen
                        disable={!id}
                        onClick={() => {
                          setIsOpenPrintDailog(true);
                        }}
                      >
                        <PrintSharp />{" "}
                        <Typography style={{ marginLeft: "5px" }}>Print Form</Typography>
                      </CommonButton>
                    </Box>
                    <VehicleDriverDetails
                      expand={expandedAccordion.vehicleDriverDetails}
                      updateExpandStatus={updateExpandedStatus}
                    />

                    <Documents
                      expand={expandedAccordion.doc}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <WebCam
                      expand={expandedAccordion.ivr}
                      updateExpandStatus={updateExpandedStatus}
                    />
                  </>
                </Container>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
